import React, { useState } from 'react';

interface Props {
  items?: string[];
}

/**
 * Collapsible "what the agent did" trail. Collapsed by default to a compact
 * "N steps" toggle; expands to show each tool step for transparency.
 */
const ToolActivity = ({ items }: Props) => {
  const [expanded, setExpanded] = useState(false);
  if (!items || items.length === 0) return null;

  const count = items.length;
  const label = `${count} step${count === 1 ? '' : 's'}`;
  const chevron = `pi ${expanded ? 'pi-chevron-up' : 'pi-chevron-down'}`;

  return (
    <div className="copilot-activity">
      <button
        type="button"
        className="copilot-activity-toggle"
        onClick={() => setExpanded((v) => !v)}
      >
        <i className="pi pi-bolt" />
        <span className="copilot-activity-count">{label}</span>
        <i className={chevron} />
      </button>

      {expanded && (
        <div className="copilot-activity-list">
          {items.map((step, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={i} className="copilot-activity-chip">{step}</span>
          ))}
        </div>
      )}
    </div>
  );
};

ToolActivity.defaultProps = {
  items: [],
};

export default ToolActivity;
